<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="desserts"
      sort-by="calories"
      class="elevation-1"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      hide-default-footer
      :search="search"
      @page-count="pageCount = $event"
    >
      <template v-slot:item.status="{ item }">
        <v-chip
          :color="getColor(item.status)"
          dark
        >
          {{ item.status }}
        </v-chip>
      </template>
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-toolbar-title>用户管理</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            clearable
            single-line
            hide-details
          />
          <v-spacer />
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                添加
              </v-btn>
            </template>
            <validation-observer
              ref="observer"
            >
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="24"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.username"
                          :rules="usernameRules"
                          label="手机号"
                          required
                        />
                      </v-col>
                      <v-col
                        cols="24"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.email"
                          :rules="emailRules"
                          label="邮箱"
                        />
                      </v-col>
                      <v-col
                        cols="24"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.name"
                          label="姓名"
                          :rules="nameRules"
                          required
                        />
                      </v-col>
                      <v-col
                        cols="24"
                        sm="12"
                        md="12"
                      >
                        <p
                          style="font-size:16px;"
                        >
                          角色
                        </p>
                        <v-radio-group
                          v-model="roles"
                          mandatory
                          row
                        >
                          <v-radio
                            v-for="n in roleList"
                            :key="n.value"
                            :label="`${n.text}`"
                            :value="n.value"
                            checked
                          />
                        </v-radio-group>
                      </v-col>
                      <v-col
                        cols="24"
                        sm="12"
                        md="12"
                      >
                        <p
                          style="font-size:16px;"
                        >
                          状态
                        </p>
                        <v-radio-group
                          v-model="editedItem.status"
                          row
                        >
                          <v-radio
                            label="启用"
                            value="1"
                          />
                          <v-radio
                            label="禁用"
                            value="0"
                          />
                        </v-radio-group>
                      </v-col>
                      <v-col
                        cols="24"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.password"
                          type="password"
                          label="密码"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    @click="close"
                  >
                    取消
                  </v-btn>
                  <v-btn
                    color="success"
                    @click="save"
                  >
                    保存
                  </v-btn>
                </v-card-actions>
              </v-card>
            </validation-observer>
          </v-dialog>
          <v-dialog
            v-model="dialogDelete"
            max-width="300px"
          >
            <v-card>
              <v-card-title
                class="headline"
              >
                请确认是否删除?
              </v-card-title>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                >
                  取消
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                >
                  确定
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template
        v-slot:item.actions="{ item }"
      >
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
      />
      <!--<v-text-field
        :value="itemsPerPage"
        label="Items per page"
        type="number"
        min="-1"
        max="15"
        @input="itemsPerPage = parseInt($event, 10)"
      />-->
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { ValidationObserver } from 'vee-validate'
  export default {
    name: 'AdminsView',
    components: {
      ValidationObserver,
    },
    data: () => ({
      radios: 1,
      search: '',
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      dialog: false,
      dialogDelete: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 12,
      roleList: [],
      roleTmp: [],
      headers: [
        {
          text: '序号',
          align: 'start',
          value: 'id',
        },
        { text: '姓名', value: 'name', sortable: false },
        { text: '手机号', value: 'username' },
        { text: '邮箱', value: 'email' },
        { text: '角色', value: 'role_name', sortable: false },
        { text: '状态', value: 'status' },
        { text: '操作', value: 'actions', sortable: false },
      ],
      desserts: [],
      editedIndex: -1,
      roles: '',
      editedItem: {
        username: '',
        email: '',
        name: '',
        roles: {},
        status: '1',
      },
      defaultItem: {
        username: '',
        name: '',
        roles: '',
        status: '1',
      },
      usernameRules: [
        v => !!v || '手机号不能为空',
        // v => /^[1][3,4,5,7,8,9][0-9]{9}$/.test(v) || '手机号格式错误',
        // v => v.length === 11 || '手机号必须为11位数',
      ],
      emailRules: [
        v => !!v || 'E-mail 不能为空',
        v => /.+@.+/.test(v) || '邮箱格式错误',
      ],
      nameRules: [
        v => !!v || '姓名不能为空',
      ],
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? '新建' : '编辑'
      },
    },

    watch: {
      dialog (val) {
        if (val === true) {
          if (this.editedIndex === -1) {
            this.roles = 'sale'
          }
        }
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        // 获取用户列表
        axios
          .get(process.env.VUE_APP_BASE_API + '/admins/list')
          .then(response => {
            if (response.status === 200) {
              // console.log(response.data.data)
              this.desserts = response.data.data.data
              this.desserts.map((item, i, arr) => {
                if (item.status === 1) {
                  item.status = '启用'
                } else {
                  item.status = '禁用'
                }
              })
              // console.log(this.desserts)
            }
          })
          .catch(error => {
            console.log(error)
          })
        /* 获取角色列表 */
        axios
          .get(process.env.VUE_APP_BASE_API + '/admins/roles')
          .then(response => {
            if (response.status === 200) {
              // console.log(response.data.data)
              response.data.data.map((item, i, arr) => {
                this.editedItem.roles[i] = {
                  text: item.name,
                  value: item.guard_name,
                }
                this.roleTmp[item.guard_name] = item.name
                this.roleList = this.editedItem.roles
              })
              // console.log(this.editedItem.roles)
            }
          })
          .catch(error => {
            console.log(error)
          })
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.status = (this.editedItem.status === '启用') ? '1' : '0'
        // console.log(_rolesing)
        this.roles = item.roles[0]
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        axios
          .delete(process.env.VUE_APP_BASE_API + '/admins/destroy/' + this.editedItem.id)
          .then(response => {
            if (response.data.code === 20000) {
              this.desserts.splice(this.editedIndex, 1)
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.$refs.observer.validate()
        const item = this.editedItem
        const _editedIndex = this.editedIndex
        const url = this.editedIndex === -1 ? process.env.VUE_APP_BASE_API + '/admins/create' : process.env.VUE_APP_BASE_API + '/admins/update/' + item.id
        const _roleTmp = this.roleTmp
        this.editedItem.roles = this.roles
        axios
          .post(url, this.editedItem)
          .then(response => {
            if (response.data.code === 20000) {
              item.status = (item.status === '1') ? '启用' : '禁用'
              item.id = response.data.data
              item.roles = (item.roles || '').split(',')
              item.role_name = [_roleTmp[item.roles]]
              console.log(item)
              if (_editedIndex > -1) {
                Object.assign(this.desserts[_editedIndex], item)
              } else {
                this.desserts.push(item)
              }
            }
          })
          .catch(error => {
            console.log(error)
          })
        this.close()
      },

      getColor (calories) {
        if (calories === '启用') return 'green'
        else return 'red'
      },

    },
  }
</script>
